var SearchLight = window.SearchLight = function () {
}

SearchLight.prototype.init = function () {
    var self = this;
    this.enadblAjaxPaginator();
    $('.confirmFullSearch2').on('change', function () {
        self.confirmFullSearch(true);
    });
}

SearchLight.prototype.reload = function () {
    var self = this;
    self.enadblAjaxPaginator();
    $('.confirmFullSearchCheckbox').on('change', function () {
        self.confirmFullSearch(false);
    });
}

SearchLight.prototype.enadblAjaxPaginator = function () {
    var self = this;
    $('.pagination a').on('click', function () {
        console.log('asdads');
        self.prependOverlayContent();
        if (history.pushState) {
            window.history.pushState({}, "", $(this).attr('href'));
        }

        $([document.documentElement, document.body]).animate({
            scrollTop: $(".scrollHere").offset().top
        }, 1000);
    });
}


SearchLight.prototype.confirmFullSearch = function () {
    var self = this;
    var url = '';
    var hasParams = false;
    var hasUrlPart = false;

    url = window.location.pathname;

    var razeniVal = $('select.select2-container.selectOrder').select2('val');
    if (razeniVal !== '4') {
        url += (hasParams ? '&razeni=' : '?razeni=') + razeniVal;
        hasParams = true;
    }

    self.changeCarList(window.location.protocol + '//' + window.location.hostname + (window.location.port != '' ? ':' + window.location.port : '') + url);
    return;
}

SearchLight.prototype.changeCarList = function (url) {
    // console.log(url);
    // return;
    var self = this;
    $.nette.ajax({
        type: 'GET',
        url: url,
        beforeSend: function () {
            self.prependOverlayContent();
            if ($(window).width() < 1083) {
                $('.search').slideUp();
                $(this).removeClass("active");
            }
        },
        success: function () {
            if (history.pushState) {
                window.history.pushState({}, "", url);
            }
            $('.animateAjaxSearch').prop("disabled", false);
            $('.overlayContent .loader-wrapper').remove();

            var viewportWidth = parseInt($(window).width());
            if (viewportWidth > 1199) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".search_right_column").offset().top
                }, 500);
            }
        }
    }).done(function () {
        if ($("#isCarSold").length) {
            if ($("#isCarSold").val() === 'true') {
                $('.list-cars-header').addClass('hidden');
            } else {
                $('.list-cars-header').removeClass('hidden');
            }
        }

        // if (self.isFullSearch) {
        //     self.pushDataLayerCategory();
        // }
    });
}

SearchLight.prototype.prependOverlayContent = function () {
    if (!$('.overlayContent .loader-wrapper').length) {
        var html = '<div class="loader-wrapper"><div class="loader-circle-wrapper"><div class="loader-circle"></div></div></div>';
        $('.overlayContent').prepend(html);
        $('.animateAjaxSearch').prop("disabled", true);
    }
}

SearchLight.prototype.pushDataLayerCategory = function () {
    if ($("#categoryId").length) {
        var self = this;
        setTimeout(function () {
            var catId = $("#categoryId").val();
            if (self.tmpCategoryId != catId) {
                dataLayer.push({
                    "rtbHouse": catId,
                    "rtbHouse_category": catId
                });
                self.tmpCategoryId = catId;
            }

        }, 1000);
    }
}

SearchLight.prototype.webalize = function (s) {
    if (s === '/')
        return s;
    var nodiac = {
        'á': 'a',
        'č': 'c',
        'ď': 'd',
        'é': 'e',
        'ě': 'e',
        'í': 'i',
        'ň': 'n',
        'ó': 'o',
        'ř': 'r',
        'š': 's',
        'ť': 't',
        'ú': 'u',
        'ů': 'u',
        'ý': 'y',
        'ž': 'z',
        'ë': 'e'
    };
    s = s.toLowerCase();
    var s2 = '';
    for (var i = 0; i < s.length; i++) {
        s2 += (typeof nodiac[s.charAt(i)] != 'undefined' ? nodiac[s.charAt(i)] : s.charAt(i));
    }
    return s2.replace(/[^a-z0-9_]+/g, '-').replace(/^-|-$/g, '');
}
